import { Component, ViewEncapsulation, HostBinding, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { NgIf } from '@angular/common';

import { NumberFormat } from '../../utils/number.format';
import { HiddenNumberPipe } from '../../pipes/hidden-number.pipe';

@Component({
	selector: 'copo-numeric-cell',
	templateUrl: './numeric-cell.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [NgIf, HiddenNumberPipe]
})
export class NumericCellComponent implements ICellRendererAngularComp {
	@HostBinding('class.passthrough') readonly passthrough = true;

	numberValue: number | undefined;
	numberFormatted: string | undefined;
	format: NumberFormat | undefined;

	constructor(readonly changeDetectorRef: ChangeDetectorRef) {}

	agInit(params: ICellRendererParams<unknown, number>) {
		this.updateValue(params);
		this.changeDetectorRef.markForCheck();
	}

	refresh(params: ICellRendererParams<unknown, number>) {
		this.updateValue(params);
		this.changeDetectorRef.markForCheck();
		return true;
	}

	private updateValue(params: ICellRendererParams<unknown, number>) {
		this.numberValue = params.value ?? undefined;
		this.numberFormatted = params.valueFormatted ?? undefined;
		if (!params.colDef) {
			return;
		}
		const { numericFormat } = <{ numericFormat?: NumberFormat }> params.colDef.cellRendererParams;
		if (!numericFormat) {
			throw new Error('numericFormat must be set in colDef');
		}
		this.format = numericFormat;
	}
}
